<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<div style="height: 100vh;  background: url(/assets/img/private-hotel-pool.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;" class="flex justify-content-center align-items-center">

  <div class="flex-column">
    <div style="width: 450px;" class="p-shadow-2">
      <p-card>
        <div class="p-4">
          <img style="width:300px;height:auto" src="assets/img/logo.png" alt="KBM Resorts Owner Login" /><br><br>
          @if (showResetForm) {
            <div>
              <div>
                <h2 style="color:grey;">Password Reset</h2>
                <p>Enter your email address below to reset your password:</p><br>
              </div>
              <form [formGroup]="form1">
                <div class="p-fluid grid">
                  <div class="p-field col-12">
                    <span class="p-float-label">
                      <input formControlName="email" id="email" type="email" pInputText>
                      <label for="password">Email Address</label>
                      @for (validation of validationMessages.email; track validation) {
                        <span>
                          @if (form1.get('email').hasError(validation.type) && (form1.get('email').dirty || form1.get('email').touched)) {
                            <small id="username2-help" class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                    <div>
                      @if (formErrorMessage) {
                        <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
                      }
                      <br>
                        <button pButton type="button" label="Reset Password" (click)="onPasswordResetRequestSubmit()"></button><br>
                      </div>
                      <div style="margin-top:100px;">
                        <button pButton type="button" label="Cancel" class="p-button-outlined" [routerLink]="'/login'"></button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }
            @if (showResetConfirm) {
              <div>
                <div>
                  <h2 style="color:grey;">Password Reset</h2>
                  <p><i class="pi pi-check-circle" style="color:green"></i>&nbsp;&nbsp;&nbsp;<b style="color:green">Success</b><br><br>Please check your email (including spam folder) for next steps.
                </p>
                <p>If you need additional assistence, don't hesitate to reach out to <a href="mailto: homeowners@kbmresorts.com">homeowners&#64;kbmresorts.com</a>.</p>
              </div>
              <div class="p-fluid grid">
                <div class="p-field col-12">
                  <div style="margin-top:100px;">
                    <button pButton type="button" label="Back to Login" class="p-button-outlined" [routerLink]="'/login'"></button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </p-card>
    </div>
  </div>
</div>
